"use client";

import SearchSelect from "./SearchSelect";
import HorizontalFilter from "./HorizontalFilter";

export default function FilterGroup({
  items = [],
  selectedItem,
  onSelect,
  searchPlaceholder = "جستجو...",
  noResultsText = "موردی یافت نشد",
  loading = false,
  className = "space-y-8",
  showSearch = true,
  showHorizontal = true,
  allLabel = "همه",
  searchClassName = "container-base max-w-6xl mx-auto",
  onSearchChange,
  searchValue,
  minSearchLength = 0,
  total,
  showBorder = true,
  viewAllLink,
  viewAllText,
  onEnter,
  showResultCount = true
}) {
  if (!items?.length && !showSearch) return null;

  return (
    <div className={className}>
      {showSearch && (
        <SearchSelect
          items={items}
          selectedItem={selectedItem}
          onSelect={onSelect}
          placeholder={searchPlaceholder}
          noResultsText={noResultsText}
          loading={loading}
          className={searchClassName}
          onSearchChange={onSearchChange}
          searchValue={searchValue}
          minSearchLength={minSearchLength}
          total={total}
          showBorder={showBorder}
          viewAllLink={viewAllLink}
          viewAllText={viewAllText}
          onEnter={onEnter}
          showResultCount={showResultCount}
        />
      )}

      {showHorizontal && (
        <HorizontalFilter
          items={items}
          selectedItem={selectedItem}
          onSelect={onSelect}
          allLabel={allLabel}
        />
      )}
    </div>
  );
}
